export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "love_report": "ಪ್ರೇಮ ವರದಿಯನ್ನು ಅನ್ವೇಷಿಸಿ",
    "cosmic_love_insights": "ಕಾಸ್ಮಿಕ್ ಪ್ರೇಮ ಒಳನೋಟಗಳು",
    "love_report_description": "ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯದ ಆಧಾರದ ಮೇಲೆ ಸಮಗ್ರ ಪ್ರೇಮ ಮತ್ತು ಸಂಬಂಧ ವಿಶ್ಲೇಷಣೆಯೊಂದಿಗೆ ನಿಮ್ಮ ಪ್ರಣಯ ಭಾಗ್ಯದ ರಹಸ್ಯಗಳನ್ನು ಬಿಚ್ಚಿಡಿ. ಹೊಂದಾಣಿಕೆ, ವಿವಾಹದ ಸಮಯ, ಆತ್ಮಸ್ನೇಹಿತರ ಗುಣಲಕ್ಷಣಗಳು ಮತ್ತು ಶಾಶ್ವತ ಪ್ರೇಮಕ್ಕಾಗಿ ವೈಯಕ್ತಿಕ ಮಾರ್ಗದರ್ಶನದ ಒಳನೋಟಗಳನ್ನು ಪಡೆಯಿರಿ.",

    // Service Information
    "enter_details_for_love_analysis": "ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_love_analysis": "ಸಂಪೂರ್ಣ ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_love_analysis_note": "ನಿಮ್ಮ ಪ್ರಣಯ ಸಾಮರ್ಥ್ಯ ಮತ್ತು ಸಂಬಂಧ ಹೊಂದಾಣಿಕೆಯ ಆಳವಾದ ವಿಶ್ಲೇಷಣೆ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_love_vibration": "ನಿಮ್ಮ ಹೆಸರು ನಿಮ್ಮ ಪ್ರಣಯ ಕಂಪನಗಳು ಮತ್ತು ಆಕರ್ಷಣೆಯ ಮಾದರಿಗಳನ್ನು ಪ್ರಭಾವಿಸುತ್ತದೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_love_compatibility": "ನಿಮ್ಮ ಪ್ರೇಮ ಮತ್ತು ಹೊಂದಾಣಿಕೆ ಮಾದರಿಗಳನ್ನು ನಿರ್ಧರಿಸಲು ಅತ್ಯಗತ್ಯ",
    "time_of_birth": "ಜನ್ಮ ಸಮಯ",
    "exact_time_critical_for_love": "ನಿಖರವಾದ ಶುಕ್ರ ಮತ್ತು ೭ನೇ ಗೃಹ ಲೆಕ್ಕಾಚಾರಗಳಿಗೆ ನಿಖರವಾದ ಸಮಯ ಅಗತ್ಯ",
    "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
    "place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
    "location_essential_for_love": "ಸ್ಥಳವು ಪ್ರೇಮ ಮತ್ತು ಸಂಬಂಧಗಳನ್ನು ಪ್ರಭಾವಿಸುವ ಗ್ರಹ ಸ್ಥಾನಗಳನ್ನು ಪರಿಣಾಮ ಬೀರುತ್ತದೆ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ನಿಮ್ಮ ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆಯನ್ನು ವಿತರಿಸಲಾಗುವುದು",

    // Core Love Features
    "love_compatibility_analysis": "ನಿಮ್ಮ ಪ್ರೇಮ ಜೀವನ ವಿಶ್ಲೇಷಣೆ",
    "relationship_potential_insights": "ಸಂಬಂಧ ಸಾಮರ್ಥ್ಯ ಒಳನೋಟಗಳು",
    "marriage_timing_predictions": "ವಿವಾಹ ಸಮಯ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "soulmate_identification": "ಆತ್ಮಸ್ನೇಹಿತರ ಗುರುತಿಸುವಿಕೆ",
    "romantic_guidance_tips": "ಪ್ರಣಯ ಮಾರ್ಗದರ್ಶನ ಸಲಹೆಗಳು",
    "pdf_download": "ಸಮಗ್ರ PDF ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆಯಲ್ಲಿ ಏನು ಸೇರಿದೆ",
    "comprehensive_love_chart": "ಸಮಗ್ರ ಪ್ರೇಮ ಚಾರ್ಟ್",
    "romantic_compatibility_score": "ಪ್ರಣಯ ಹೊಂದಾಣಿಕೆ ಅಂಕ",
    "relationship_guidance": "ಸಂಬಂಧ ಮಾರ್ಗದರ್ಶನ",
    "marriage_timing_insights": "ವಿವಾಹ ಸಮಯ ಒಳನೋಟಗಳು",

    // Actions & Buttons
    "pay_and_generate_analysis_love": "ನನ್ನ ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆ ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿ ಸಂಸ್ಕರಿಸುತ್ತಿದೆ",
    "processing_request": "ವಿಶ್ಲೇಷಣೆ ರಚಿಸುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "love_analysis_processing": "ನಿಮ್ಮ ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ಪರಿಣಿತ ಸಂಬಂಧ ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ನಿಮ್ಮ ಪ್ರಣಯ ಭಾಗ್ಯ ಮತ್ತು ಹೊಂದಾಣಿಕೆ ಮಾದರಿಗಳ ಬಗ್ಗೆ ವಿಸ್ತೃತ ಒಳನೋಟಗಳನ್ನು ನೀವು ಸ್ವೀಕರಿಸುತ್ತೀರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_12_hours_delivery_note_love": "ನಿಮ್ಮ ವಿಸ್ತೃತ ಪ್ರೇಮ ವರದಿ ೧೨ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತಕ್ಷಣ ಅಧಿಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ವಿತರಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆ ಪ್ಯಾಕೇಜ್",
    "detailed_love_report": "ಸಮಗ್ರ ಪ್ರೇಮ ವರದಿ (PDF)",
    "compatibility_analysis_detailed": "ವಿಸ್ತೃತ ಹೊಂದಾಣಿಕೆ ವಿಶ್ಲೇಷಣೆ",
    "relationship_timing_predictions": "ಸಂಬಂಧ ಸಮಯ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "soulmate_characteristics": "ಆತ್ಮಸ್ನೇಹಿತರ ಗುಣಲಕ್ಷಣಗಳ ಪ್ರೊಫೈಲ್",
    "romantic_enhancement_tips": "ಪ್ರಣಯ ವರ್ಧನೆ ಸಲಹೆಗಳು",

    // Visual Content
    "sample_love_analysis": "ಮಾದರಿ ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆ",
    "love_compatibility_score": "ನಿಮ್ಮ ಪ್ರೇಮ ಜೀವನ ಅಂಕ",
    "sample_love_reading": "ಆಳವಾದ ಭಾವನಾತ್ಮಕ ಸಂಪರ್ಕದೊಂದಿಗೆ ಹೆಚ್ಚಿನ ಪ್ರಣಯ ಸಾಮರ್ಥ್ಯ",
    "sample_love_preview": "ಹೊಂದಾಣಿಕೆ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆಯ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "love_analysis_categories": "ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆ ವರ್ಗಗಳು",

    // Love Category Types
    "compatibility": "ಹೊಂದಾಣಿಕೆ",
    "romance": "ಪ್ರಣಯ",
    "marriage": "ವಿವಾಹ",
    "soulmate": "ಆತ್ಮಸ್ನೇಹಿತ",
    "attraction": "ಆಕರ್ಷಣೆ",
    "passion": "ಭಾವೋದ್ರೇಕ",

    // Status & Processing
    "your_love_analysis_status": "ನಿಮ್ಮ ಪ್ರೇಮ ವಿಶ್ಲೇಷಣೆ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ಪ್ರೇಮ ಮಾದರಿಗಳನ್ನು ವಿಶ್ಲೇಷಿಸುತ್ತಿದೆ",
    "analysis_processing_message": "ನಮ್ಮ ಸಂಬಂಧ ಜ್ಯೋತಿಷ್ಯ ಪರಿಣಿತರು ನಿಮ್ಮ ಪ್ರಣಯ ಹೊಂದಾಣಿಕೆ ಮತ್ತು ಪ್ರೇಮ ಭಾಗ್ಯವನ್ನು ನಿರ್ಧರಿಸಲು ನಿಮ್ಮ ಶುಕ್ರ ಸ್ಥಾನ ಮತ್ತು ೭ನೇ ಗೃಹವನ್ನು ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸರದಿಯಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_12_hours": "ವರದಿ ೧೨ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ಪ್ರೇಮ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ಜನ್ಮ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಸಂಸ್ಕರಣೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Love-Specific Elements
    "seventh_house": "೭ನೇ ಗೃಹ (ವಿವಾಹ ಗೃಹ)",
    "venus_position": "ಶುಕ್ರ ಸ್ಥಾನ ಮತ್ತು ಪ್ರಭಾವ",
    "mars_influence": "ಮಂಗಳ ಮತ್ತು ಭಾವೋದ್ರೇಕ ಸೂಚಕಗಳು",
    "moon_emotions": "ಚಂದ್ರ ಮತ್ತು ಭಾವನಾತ್ಮಕ ಹೊಂದಾಣಿಕೆ",
    "jupiter_blessings": "ಪ್ರೇಮದಲ್ಲಿ ಗುರುವಿನ ಆಶೀರ್ವಾದಗಳು",
    "love_yogas": "ಪ್ರೇಮ ಮತ್ತು ವಿವಾಹ ಯೋಗಗಳು",

    // Compatibility Analysis
    "zodiac_compatibility": "ರಾಶಿ ಚಿಹ್ನೆ ಹೊಂದಾಣಿಕೆ",
    "nakshatra_matching": "ನಕ್ಷತ್ರ ಹೊಂದಾಣಿಕೆ",
    "guna_milan": "ಗುಣ ಮಿಲನ ವಿಶ್ಲೇಷಣೆ",
    "doshas_matching": "ದೋಷ ಹೊಂದಾಣಿಕೆ ತಪಾಸಣೆ",
    "planetary_harmony": "ಗ್ರಹ ಸಾಮರಸ್ಯ ಅಂಕ",
    "elemental_compatibility": "ಮೂಲ ಅಂಶ ಹೊಂದಾಣಿಕೆ",

    // Love Personality Analysis
    "romantic_nature": "ಪ್ರಣಯ ಸ್ವಭಾವ ಮತ್ತು ಶೈಲಿ",
    "love_language": "ನಿಮ್ಮ ಪ್ರೇಮ ಭಾಷೆ",
    "emotional_needs": "ಸಂಬಂಧಗಳಲ್ಲಿ ಭಾವನಾತ್ಮಕ ಅಗತ್ಯತೆಗಳು",
    "attraction_patterns": "ಆಕರ್ಷಣೆಯ ಮಾದರಿಗಳು",
    "relationship_approach": "ಸಂಬಂಧ ವಿಧಾನ ಶೈಲಿ",
    "commitment_style": "ಬದ್ಧತೆ ಮತ್ತು ನಿಷ್ಠೆಯ ಶೈಲಿ",

    // Soulmate Analysis
    "soulmate_characteristics": "ಆತ್ಮಸ್ನೇಹಿತರ ಗುಣಲಕ್ಷಣಗಳು",
    "ideal_partner_traits": "ಆದರ್ಶ ಪಾಲುದಾರರ ಗುಣಲಕ್ಷಣಗಳು",
    "soulmate_timing": "ನೀವು ನಿಮ್ಮ ಆತ್ಮಸ್ನೇಹಿತನ್ನು ಯಾವಾಗ ಭೇಟಿಯಾಗುತ್ತೀರಿ",
    "recognition_signs": "ಆತ್ಮಸ್ನೇಹಿತರ ಗುರುತಿಸುವ ಚಿಹ್ನೆಗಳು",
    "karmic_connections": "ಕಾರ್ಮಿಕ ಪ್ರೇಮ ಸಂಪರ್ಕಗಳು",
    "twin_flame_indicators": "ಅವಳಿ ಜ್ವಾಲೆ ಸೂಚಕಗಳು",

    // Marriage Predictions
    "marriage_timing": "ವಿವಾಹ ಸಮಯ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "wedding_auspicious_dates": "ಶುಭ ವಿವಾಹದ ದಿನಾಂಕಗಳು",
    "married_life_forecast": "ವೈವಾಹಿಕ ಜೀವನ ಮುನ್ಸೂಚನೆ",
    "spouse_characteristics": "ಜೀವನಸಂಗಾತಿಯ ಗುಣಲಕ್ಷಣಗಳು",
    "marriage_compatibility": "ವಿವಾಹ ಹೊಂದಾಣಿಕೆ ಅಂಕ",
    "family_harmony": "ಕುಟುಂಬ ಸಾಮರಸ್ಯ ನಿರೀಕ್ಷೆಗಳು",

    // Relationship Phases
    "dating_guidance": "ಡೇಟಿಂಗ್ ಹಂತ ಮಾರ್ಗದರ್ಶನ",
    "courtship_period": "ಪ್ರಣಯ ಅವಧಿ ಒಳನೋಟಗಳು",
    "engagement_timing": "ನಿಶ್ಚಿತಾರ್ಥದ ಸಮಯ",
    "pre_marriage_guidance": "ವಿವಾಹ ಪೂರ್ವ ಮಾರ್ಗದರ್ಶನ",
    "honeymoon_phase": "ಹನಿಮೂನ್ ಹಂತ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "long_term_relationship": "ದೀರ್ಘಾವಧಿ ಸಂಬಂಧ ಮುನ್ಸೂಚನೆ",

    // Love Challenges & Solutions
    "relationship_challenges": "ಸಂಭಾವ್ಯ ಸಂಬಂಧ ಸವಾಲುಗಳು",
    "compatibility_issues": "ಪರಿಹರಿಸಬೇಕಾದ ಹೊಂದಾಣಿಕೆ ಸಮಸ್ಯೆಗಳು",
    "communication_style": "ಸಂವಹನ ಶೈಲಿ ಹೊಂದಾಣಿಕೆ",
    "conflict_resolution": "ಸಂಘರ್ಷ ಪರಿಹಾರ ಮಾರ್ಗದರ್ಶನ",
    "trust_building": "ನಂಬಿಕೆ ನಿರ್ಮಾಣ ಕಾರ್ಯತಂತ್ರಗಳು",
    "intimacy_enhancement": "ಅನ್ಯೋನ್ಯತೆ ವರ್ಧನೆ ಸಲಹೆಗಳು",

    // Romantic Timing
    "love_favorable_periods": "ಪ್ರೇಮ ಅನುಕೂಲ ಅವಧಿಗಳು",
    "romantic_peak_times": "ಪ್ರಣಯ ಶಿಖರ ಸಮಯಗಳು",
    "proposal_timing": "ಅತ್ಯುತ್ತಮ ಪ್ರಸ್ತಾವನೆ ಸಮಯ",
    "relationship_milestones": "ಸಂಬಂಧದ ಮೈಲಿಗಲ್ಲು ಸಮಯ",
    "anniversary_significance": "ವಾರ್ಷಿಕೋತ್ಸವದ ಮಹತ್ವ",
    "renewal_periods": "ಸಂಬಂಧ ನವೀಕರಣ ಅವಧಿಗಳು",

    // Venus Analysis
    "venus_sign_influence": "ಶುಕ್ರ ರಾಶಿ ಪ್ರಭಾವ",
    "venus_house_position": "ಶುಕ್ರ ಗೃಹ ಸ್ಥಾನ",
    "venus_aspects": "ಶುಕ್ರ ಗ್ರಹ ದೃಷ್ಟಿಗಳು",
    "venus_dignity": "ಶುಕ್ರ ಶಕ್ತಿ ಮತ್ತು ಘನತೆ",
    "venus_remedies": "ಶುಕ್ರ ವರ್ಧನೆ ಪರಿಹಾರಗಳು",
    "venus_mantras": "ಶುಕ್ರ ಪ್ರೇಮ ಮಂತ್ರಗಳು",

    // Love Types & Styles
    "passionate_love": "ಭಾವೋದ್ರೇಕ ಪ್ರೇಮ ಸೂಚಕಗಳು",
    "companionate_love": "ಸಂಗಾತಿ ಪ್ರೇಮ ಶೈಲಿ",
    "romantic_love": "ಪ್ರಣಯ ಪ್ರೇಮ ಅಭಿವ್ಯಕ್ತಿ",
    "unconditional_love": "ಷರತ್ತುರಹಿತ ಪ್ರೇಮ ಸಾಮರ್ಥ್ಯ",
    "spiritual_love": "ಆಧ್ಯಾತ್ಮಿಕ ಪ್ರೇಮ ಸಂಪರ್ಕ",
    "platonic_relationships": "ಪ್ಲಾಟೋನಿಕ್ ಸಂಬಂಧ ಒಳನೋಟಗಳು",

    // Compatibility Factors
    "mental_compatibility": "ಮಾನಸಿಕ ಹೊಂದಾಣಿಕೆ",
    "emotional_compatibility": "ಭಾವನಾತ್ಮಕ ಹೊಂದಾಣಿಕೆ",
    "physical_compatibility": "ದೈಹಿಕ ಹೊಂದಾಣಿಕೆ",
    "spiritual_compatibility": "ಆಧ್ಯಾತ್ಮಿಕ ಹೊಂದಾಣಿಕೆ",
    "lifestyle_compatibility": "ಜೀವನಶೈಲಿ ಹೊಂದಾಣಿಕೆ",
    "financial_compatibility": "ವಿವಾಹದಲ್ಲಿ ಹಣಕಾಸಿನ ಹೊಂದಾಣಿಕೆ",

    // Love Remedies
    "love_enhancing_remedies": "ಪ್ರೇಮ ವರ್ಧಿಸುವ ಪರಿಹಾರಗಳು",
    "relationship_healing": "ಸಂಬಂಧ ಚಿಕಿತ್ಸಾ ಅಭ್ಯಾಸಗಳು",
    "attraction_remedies": "ಆಕರ್ಷಣೆ ವರ್ಧನೆ ಪರಿಹಾರಗಳು",
    "marriage_delay_remedies": "ವಿವಾಹ ವಿಳಂಬ ಪರಿಹಾರಗಳು",
    "love_gemstones": "ಪ್ರೇಮ ಮತ್ತು ಸಂಬಂಧ ರತ್ನಗಳು",
    "romantic_rituals": "ಪ್ರಣಯ ವಿಧಿಗಳು ಮತ್ತು ಅಭ್ಯಾಸಗಳು",

    // Past Life & Karma
    "past_life_love_connections": "ಹಿಂದಿನ ಜನ್ಮದ ಪ್ರೇಮ ಸಂಪರ್ಕಗಳು",
    "karmic_relationships": "ಕಾರ್ಮಿಕ ಸಂಬಂಧ ಮಾದರಿಗಳು",
    "soul_contracts": "ಪ್ರೇಮದಲ್ಲಿ ಆತ್ಮ ಒಪ್ಪಂದಗಳು",
    "karmic_debt_love": "ಸಂಬಂಧಗಳಲ್ಲಿ ಕಾರ್ಮಿಕ ಋಣ",
    "spiritual_lessons_love": "ಪ್ರೇಮದ ಮೂಲಕ ಆಧ್ಯಾತ್ಮಿಕ ಪಾಠಗಳು",
    "past_life_spouse": "ಹಿಂದಿನ ಜನ್ಮದ ಜೀವನಸಂಗಾತಿ ಸಂಪರ್ಕಗಳು",

    // Love Forecast
    "monthly_love_forecast": "ಮಾಸಿಕ ಪ್ರೇಮ ಮುನ್ಸೂಚನೆ",
    "yearly_romance_predictions": "ವಾರ್ಷಿಕ ಪ್ರಣಯ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "love_life_phases": "ಪ್ರೇಮ ಜೀವನ ಹಂತಗಳು",
    "relationship_cycles": "ಸಂಬಂಧ ಚಕ್ರಗಳು",
    "romantic_opportunities": "ಮುಂದೆ ಪ್ರಣಯ ಅವಕಾಶಗಳು",
    "love_life_transformation": "ಪ್ರೇಮ ಜೀವನ ರೂಪಾಂತರ ಅವಧಿಗಳು",

    // Special Love Scenarios
    "second_marriage": "ಎರಡನೇ ವಿವಾಹದ ಸಾಧ್ಯತೆಗಳು",
    "late_marriage": "ತಡವಾದ ವಿವಾಹ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "love_marriage_vs_arranged": "ಪ್ರೇಮ ವಿವಾಹ ಮತ್ತು ಶಿಷ್ಟಾಚಾರ ವಿವಾಹ",
    "intercaste_marriage": "ಅಂತರ್ಜಾತಿ ವಿವಾಹ ನಿರೀಕ್ಷೆಗಳು",
    "foreign_spouse": "ವಿದೇಶಿ ಜೀವನಸಂಗಾತಿ ಸಾಧ್ಯತೆಗಳು",
    "celebrity_romance": "ಉನ್ನತ-ಪ್ರೊಫೈಲ್ ಪ್ರಣಯ ಸೂಚಕಗಳು",

    // Relationship Counseling
    "pre_marital_counseling": "ವಿವಾಹ ಪೂರ್ವ ಜ್ಯೋತಿಷ್ಯ ಸಲಹೆ",
    "relationship_therapy": "ಜ್ಯೋತಿಷ್ಯ ಸಂಬಂಧ ಚಿಕಿತ್ಸೆ",
    "couple_compatibility": "ದಂಪತಿ ಹೊಂದಾಣಿಕೆ ವರ್ಧನೆ",
    "marriage_counseling": "ವಿವಾಹ ಸಲಹಾ ಒಳನೋಟಗಳು",
    "relationship_revival": "ಸಂಬಂಧ ಪುನರುಜ್ಜೀವನ ಮಾರ್ಗದರ್ಶನ",
    "love_life_coaching": "ಪ್ರೇಮ ಜೀವನ ಕೋಚಿಂಗ್",

    // Advanced Love Analysis
    "composite_chart_analysis": "ಸಂಯೋಜಿತ ಚಾರ್ಟ್ ವಿಶ್ಲೇಷಣೆ",
    "synastry_compatibility": "ಸಿನಾಸ್ಟ್ರಿ ಹೊಂದಾಣಿಕೆ ವಾಚನ",
    "davison_relationship_chart": "ಡೇವಿಸನ್ ಸಂಬಂಧ ಚಾರ್ಟ್",
    "progressed_love_indicators": "ಪ್ರಗತಿಶೀಲ ಪ್ರೇಮ ಸೂಚಕಗಳು",
    "solar_return_love": "ಸೌರ ವಾಪಸಾತಿ ಪ್ರೇಮ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "lunar_return_romance": "ಚಂದ್ರ ವಾಪಸಾತಿ ಪ್ರಣಯ ಒಳನೋಟಗಳು"
};
